import React from "react";
import {
    TableRow,
    TableCell,
    IconButton,
    Collapse,
    Table,
    TableHead,
    TableBody,
} from "material-ui";
import moment from "moment";
import MinusIcon from "./MinusIcon";
import PlusIcon from "./PlusIcon";
import { PaymentPlanDto } from "util/DTOs/PaymentPlanDtos";
import { formatNumber } from "util/utils";

import "./index.scss";

interface RowProps {
    row: PaymentPlanDto;
}

interface RowState {
    isOpen: boolean;
}

class Row extends React.Component<RowProps, RowState> {
    constructor(props: RowProps) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    setOpen = (isOpen: boolean) => {
        this.setState({ isOpen });
    };

    render() {
        return (
            <React.Fragment>
                <TableRow
                    className="collapsible-table-row"
                    style={{
                        backgroundColor: this.state.isOpen
                            ? "rgba(189, 188, 188, 0.2)"
                            : "transparent",
                        borderLeft: this.state.isOpen
                            ? "2px solid #004170"
                            : "unset",
                        margin: "1px 0",
                    }}
                >
                    <TableCell
                        padding="none"
                        className="collapsible-table-cell"
                        style={{
                            padding: "0 5px",
                            fontWeight: this.state.isOpen ? 700 : 400,
                        }}
                    >
                        {moment(this.props.row.dueDate).format("DD.MM.YYYY")}
                    </TableCell>
                    <TableCell
                        padding="none"
                        className="collapsible-table-cell"
                        style={{
                            fontWeight: this.state.isOpen ? 700 : 400,
                        }}
                    >{`${formatNumber(
                        this.props.row.paymentAmount,
                        2
                    )} €`}</TableCell>
                    <TableCell
                        padding="none"
                        className="collapsible-table-cell"
                        style={{
                            fontWeight: this.state.isOpen ? 700 : 400,
                        }}
                    >{`${formatNumber(
                        this.props.row.remainingAmount,
                        2
                    )} €`}</TableCell>
                    <TableCell
                        padding="none"
                        className="collapsible-table-button-cell"
                    >
                        <IconButton
                            aria-label={`${
                                this.state.isOpen ? "Sulje" : "Avaa"
                            } rivin lisätiedot`}
                            onClick={() => this.setOpen(!this.state.isOpen)}
                            className="collapse-row-button"
                        >
                            {this.state.isOpen ? <MinusIcon /> : <PlusIcon />}
                        </IconButton>
                    </TableCell>
                </TableRow>
                <TableRow style={{ height: 0 }}>
                    <TableCell
                        padding="none"
                        style={{
                            paddingBottom: 0,
                            paddingTop: 0,
                            borderBottom: "unset",
                            backgroundColor: "rgba(146, 201, 240, 0.2)",
                            borderLeft: "2px solid #004170",
                        }}
                        colSpan={4}
                    >
                        <Collapse
                            in={this.state.isOpen}
                            timeout="auto"
                            unmountOnExit
                        >
                            <Table className="additional-info-table">
                                <TableBody>
                                    <TableRow className="collapsible-table-row">
                                        <TableCell
                                            padding="none"
                                            className="collapsible-table-cell"
                                        >
                                            Lyhennys
                                        </TableCell>
                                        <TableCell
                                            padding="none"
                                            className="collapsible-table-cell"
                                        >
                                            Korot
                                        </TableCell>
                                        <TableCell
                                            padding="none"
                                            className="collapsible-table-cell"
                                        >
                                            Kulut
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                                <TableBody>
                                    <TableRow className="collapsible-table-row">
                                        <TableCell
                                            padding="none"
                                            className="collapsible-table-cell additional-info-value"
                                        >
                                            {formatNumber(
                                                this.props.row.instalmentAmount
                                            )}{" "}
                                            €
                                        </TableCell>
                                        <TableCell
                                            padding="none"
                                            className="collapsible-table-cell additional-info-value"
                                        >
                                            {formatNumber(
                                                this.props.row.interestAmount
                                            )}{" "}
                                            €
                                        </TableCell>
                                        <TableCell
                                            padding="none"
                                            className="collapsible-table-cell additional-info-value"
                                        >
                                            {formatNumber(
                                                this.props.row.expenses
                                            )}{" "}
                                            €
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }
}

interface CollapsibleTableProps {
    data: PaymentPlanDto[];
}

class CollapsibleTable extends React.Component<CollapsibleTableProps> {
    constructor(props: CollapsibleTableProps) {
        super(props);
    }
    render() {
        return (
            <Table aria-label="collapsible table" className="collapsible-table">
                <TableHead className="collapsible-table-head">
                    <TableRow className="collapsible-table-row">
                        <TableCell
                            padding="none"
                            className="collapsible-table-cell"
                            style={{ paddingLeft: "5px" }}
                        >
                            Eräpäivä
                        </TableCell>
                        <TableCell
                            padding="none"
                            className="collapsible-table-cell"
                            style={{ paddingRight: "5px" }}
                        >
                            Maksuerä
                        </TableCell>
                        <TableCell
                            padding="none"
                            className="collapsible-table-cell"
                        >
                            Saldo
                        </TableCell>
                        <TableCell
                            aria-label="Avaa rivin lisätiedot-painike"
                            padding="none"
                            className="collapsible-table-cell"
                        />
                    </TableRow>
                </TableHead>
                <TableBody className="collapsible-table-body">
                    {this.props.data.map((row, idx) => (
                        <React.Fragment key={`PaymentPlan_TableRow_${idx}`}>
                            <Row row={row} />
                            <TableRow style={{ height: "2px" }}></TableRow>
                        </React.Fragment>
                    ))}
                </TableBody>
            </Table>
        );
    }
}

export default CollapsibleTable;



// WEBPACK FOOTER //
// ./src/components/CollapsibleTable/index.tsx